import React from 'react'
import { get } from 'lodash'

import { SearchSelect } from '../common/SearchSelect'
import { useListRequest } from '../../hooks/request'
import { getFullName } from '../../utils/getFullName'
import { ROLES_FACM_SUBMITTERS } from '../../constants/roles'
import { userList } from '../../requests/user'

const getOptionLabel = (o) => getFullName({ user: o })
const getOptionValue = (o) => o && o.id

export const UserSelect = ({
  onChange, placeholder, startFilter, ...rest
}) => {
  const userListRequest = useListRequest({
    startFilter: {
      role: startFilter || ROLES_FACM_SUBMITTERS,
    },
    request: userList,
    start: true,
  })

  const onSearch = userListRequest.setSearch

  const options = get(userListRequest.state.data, 'docs', [])
  const finalOnChange = (val) => {
    if (val === null) {
      return onChange('')
    }

    onChange(val)
  }

  return (
    <SearchSelect
      isClearable
      onSearch={onSearch}
      placeholder={placeholder || 'lookForUserPlaceholder'}
      getOptionLabel={getOptionLabel}
      translatePlaceholder={!rest.prefilledText}
      getOptionValue={getOptionValue}
      onChange={finalOnChange}
      options={options}
      {...rest}
    />
  )
}
